export default {
  UserManagement: require('./user-management').default,
}